/* RovoSearchHeaderIllustration.styles.compiled.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAYvD1%7Boverflow-x%3Avisible%7D%0A._2WAcuGYvD1%7Boverflow-y%3Avisible%7D%0A%40keyframes%20ktb04qe%7B0%25%7Btransform%3AtranslateY(0)%20scale(1)%7Dto%7Btransform%3AtranslateY(0)%20scale(1)%7D50%25%7Btransform%3AtranslateY(-8px)%20scale(1.04)%7D%7D%0A._0nFVCGYTUA%7Banimation-duration%3A5.5s%7D%0A._03m2nySHWH%7Banimation-iteration-count%3Ainfinite%7D%0A._1gBibyvBkZ%7Banimation-name%3Aktb04qe%7D%0A._43vdfTL9bk%7Banimation-timing-function%3Acubic-bezier(.45%2C0%2C.55%2C1)%7D%0A._2WT4cdNwwZ%7Btransform-box%3Afill-box%7D%0A._0yKXXaDIqT%7Btransform-origin%3Acenter%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._0LqqFdYbGa%7Banimation-name%3Anone%7D%7D%0A._2ALXOxqiEI%7Bmask-type%3Aluminance%7D%0A%40keyframes%20kz5ax8h%7B0%25%7Bopacity%3A.9%3Btransform%3Ascale(1)%7D70%25%7Bopacity%3A.9%3Btransform%3Ascale(1)%7Dto%7Bopacity%3A.9%3Btransform%3Ascale(1)%7D35%25%7Bopacity%3A.35%3Btransform%3Ascale(.82)%7D%7D%0A._0nFVCGqNYF%7Banimation-duration%3A3.2s%7D%0A._1gBibyJO7I%7Banimation-name%3Akz5ax8h%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._0LqqFdYbGa%7Banimation-name%3Anone%7D._1sHUMg7dHp%7Bopacity%3A1%7D%7D%0A._1jakNnwiJJ%7Banimation-delay%3A.5s%7D%0A._1jakNnWpQH%7Banimation-delay%3A1.1s%7D%0A._1jakNnUaiG%7Banimation-delay%3A0ms%7D");

















import { type ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- jsx is used by the JSX pragma

const BREATH_DURATION = '5500ms';
const TWINKLE_DURATION = '3200ms';

/**
 * A symmetric curve, so the loop reads the same in both directions. ADS has no
 * equivalent motion easing token: `motion.easing.inout.bold` is
 * cubic-bezier(0.4, 0, 0, 1), which is asymmetric and lands hard at one end.
 */
const SYMMETRIC_EASING = 'cubic-bezier(0.45, 0, 0.55, 1)';

/**
 * Amplitude is deliberate: a couple of pixels on an ~90px illustration reads as
 * nothing, so the lift is 8px plus a 4% scale breath.
 */
const floatKeyframes = null;
const twinkleKeyframes = null;
const svgStyles = null;
const floatStyles = null;
const twinkleStyles = null;
const firstTwinkleStyles = null;
const secondTwinkleStyles = null;
const thirdTwinkleStyles = null;
const luminanceMaskStyles = null;
interface WrapperProps {
  children: ReactNode;
}
export function IllustrationSvg({
  children,
  ...svgProps
}: WrapperProps & JSX.IntrinsicElements['svg']): JSX.Element {
  return <svg {...svgProps} className={ax(["_4bt5LAYvD1 _2WAcuGYvD1"])}>
			{children}
		</svg>;
}
export function FloatingGroup({
  children
}: WrapperProps): JSX.Element {
  return <g className={ax(["_0nFVCGYTUA _03m2nySHWH _1gBibyvBkZ _43vdfTL9bk _2WT4cdNwwZ _0yKXXaDIqT _0LqqFdYbGa"])}>{children}</g>;
}
export function LuminanceMask({
  children,
  ...maskProps
}: WrapperProps & JSX.IntrinsicElements['mask']): JSX.Element {
  return <mask {...maskProps} className={ax(["_2ALXOxqiEI"])}>
			{children}
		</mask>;
}
type TwinkleGroupProps = WrapperProps & {
  variant: number;
};

/**
 * Wraps rather than styles the spark directly: each spark path carries its own
 * `transform` attribute for positioning, and a CSS `transform` on the path
 * would override it and collapse the spark onto the origin.
 */
export function TwinkleGroup({
  children,
  variant
}: TwinkleGroupProps): JSX.Element {
  if (variant === 1) {
    return <g className={ax(["_0nFVCGqNYF _03m2nySHWH _1gBibyJO7I _43vdfTL9bk _2WT4cdNwwZ _0yKXXaDIqT _0LqqFdYbGa _1sHUMg7dHp", "_1jakNnwiJJ"])}>{children}</g>;
  }
  if (variant === 2) {
    return <g className={ax(["_0nFVCGqNYF _03m2nySHWH _1gBibyJO7I _43vdfTL9bk _2WT4cdNwwZ _0yKXXaDIqT _0LqqFdYbGa _1sHUMg7dHp", "_1jakNnWpQH"])}>{children}</g>;
  }
  return <g className={ax(["_0nFVCGqNYF _03m2nySHWH _1gBibyJO7I _43vdfTL9bk _2WT4cdNwwZ _0yKXXaDIqT _0LqqFdYbGa _1sHUMg7dHp", "_1jakNnUaiG"])}>{children}</g>;
}